import React, {Component} from 'react';
import {Modal, Button, Tooltip} from 'antd';
import IconSmoke from '../style/icon/IconSmoke'
import IconFire from '../style/icon/IconFire'
import IconDoorClosed from '../style/icon/IconDoorClosed'
import IconDoorOpened from '../style/icon/IconDoorOpened'
import IconMotion from '../style/icon/IconMotion'
import IconWarning from '../style/icon/IconWarning'

import {
  SUB_CATEGORY_SMOKE,
  SUB_CATEGORY_HEAT_EXCEED,
  SUB_CATEGORY_DOOR,
  SUB_CATEGORY_DOOR_IN_HOUSE,
  SUB_CATEGORY_MOTION,
  DEVICE_STATUS_COLOR_ON,
  DEVICE_STATUS_STATE_ON
} from '../constants/defaultValues'
import {timeAgoVnShortFromEpochTime} from '../utils'

class ModalDeviceDIN extends Component {
  displayDevice(dev) {
    switch (dev.SubCategory) {
      case SUB_CATEGORY_SMOKE:
        return <IconSmoke color={dev.Color
} size="lg"/>
      case SUB_CATEGORY_HEAT_EXCEED:
        return <IconFire color={dev.Color
} size="lg"/>
      case SUB_CATEGORY_DOOR:
      case SUB_CATEGORY_DOOR_IN_HOUSE:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          return <IconDoorOpened color={dev.Color
} size="lg"/>
        } else {
          return <IconDoorClosed color={dev.Color
} size="lg"/>
        }
      case SUB_CATEGORY_MOTION:
        return <IconMotion color={dev.Color
} size="lg"/>
      default:
        return <span>{dev.Name}</span>
    }
  }

  handleTimeLineClick = (dev) => {
    this.props.onTimeLineClick(dev)
  }

  render() {
    const {visible, onCancel, device, sending} = this.props

    const icon = this.displayDevice(device)
    const roomName = device.RoomName && device.RoomName !== "Default"
      ? device.RoomName.toLowerCase()
      : ""
    const deviceName = device && device.Name !== ""
      ? device.Name
      : ""
    const title = `${deviceName} ${roomName}`
    const disconnected = device.Disconnected
    const {time, inHours} = timeAgoVnShortFromEpochTime(device.Time)
    const timeColor = inHours === true
      ? {
        color: DEVICE_STATUS_COLOR_ON
      }
      : null
    return (<Modal visible={visible} title={title} onCancel={onCancel} footer={[<Button key="cancel" onClick={onCancel}>Bỏ qua</Button>
        ]}>
      <div className="form-device-relay">
        <div className="box-device">
          <div>
            <span className="text" style={{
                color: device.Color
              }}>{device.Text}</span>
            <span className="time" style={timeColor}>{time}</span>
          </div>
          <span className="line-chart">
            <Tooltip placement="left" title="Lịch sử trạng thái">
              <Button type="primary" ghost={true} shape="circle" icon="bar-chart" onClick={() => this.handleTimeLineClick(device)}></Button>
            </Tooltip>
          </span>
          {icon}
          {
            device.Disconnected
              ? <div className="value">
                  <span className="disconnected"><IconWarning/></span>
                </div>
              : null
          }
        </div>
      </div>
    </Modal>);
  }
}
export default ModalDeviceDIN;



// WEBPACK FOOTER //
// ./src/components/ModalDeviceDIN.js